import { IntegrationSchedule } from '@ardoq/api-types';
import { fetchEntities } from '../api';

export const integrationsJobApi = {
  fetchAll: fetchEntities<IntegrationSchedule>('integrations/job'),
};
